import React, { useRef, useEffect, useState, useCallback } from 'react';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import CustomKeyboard from '@components/common/CustomKeyboardCopy/indexRevamp';
import Modal from '@components/common/Modal';
import FullWidthModal from '@components/common/Modal/FullWidthModal';
import Loader from '@components/common/Loader/newLoaderModal';
import cn from 'classnames';
import style from './CardEntry.module.scss';
import { APP_CONFIG } from '@constants';
import { flowType } from '@utility/userInfo';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import swipeGameCard from '@assets/images/GIFs/Swipe_Game_Card.gif';
import {
  TouchableDiv,
  TouchableButton,
} from '@components/common/Touchable';
import { urlSearchParams } from '../../utility/utills';
import ModalHeader from '../../components/common/ModalHeader/index';

const CardEntry = props => {
  // Props Destructuring

  const {
    handlegameCardProcess,
    openCardPopUp,
    handleStopMagneticRead,
    isSwipe,
    cardError,
    loading,
    orderingPortraitOrientation,
    setCardError,
    balancePopUp,
    handleClosePopup,
    serverAppTheme,
    auth,
    setErrorPopUp
  } = props;

  // State Management

  const [inputs, setInputs] = useState('');
  const [swipedDown, setSwipedDown] = useState(false);
  const [activeElement, setActiveElement] = useState('cardNumber');
  const ref = useRef(null);
  const keyboard = useRef(null);
  const [balTran, setBalTran] = useState(false);
  const entryMethods = auth?.gamingSystemConfig?.entryMethods || [];

  // Stable refs — read at call time so useCallback deps stay empty
  const activeElementRef = useRef(activeElement);
  activeElementRef.current = activeElement;
  // React Hooks


  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);

  // Methods

  const handleClickOutside = e => {
    if (ref.current && !ref.current.contains(e.target)) {
      setSwipedDown(false);
    }
  };

  const getInput = key => {
    return inputs[key];
  };

  const handleBlur = () => {
    if (document.querySelector('#cardNumber')) {
      document.querySelector('#cardNumber').blur();
    }
  };

  const handleChangeInput = data => {
    setSwipedDown(true);
    if (keyboard.current) {
      keyboard.current.setInput(inputs[data], data);
    }
  };

  const closeKeyboard = useCallback(() => {
    setSwipedDown(false);
  }, []);

  // Stable reference — reads activeElement via ref, uses functional updater
  // for setInputs so it never needs to close over state.
  const onClickBtn = useCallback(e => {
    const currentActive = activeElementRef.current;
    setInputs(prev => {
      const prevVal = (prev && prev[currentActive]) || '';
      const newVal = e === '{bksp}' ? prevVal.slice(0, -1) : prevVal.concat(e);
      return { ...prev, [currentActive]: newVal };
    });
  }, []);

  const setEmpty = useCallback(data => {
    setInputs(prev => ({ ...prev, [data]: '' }));
  }, []);

  const handleClosePopuo = () => {
    setCardError(false);
  };

  const handleApplyGameCard = () => {
    if (!(inputs?.cardNumber?.length === 0 || inputs == '')) {
      handlegameCardProcess(inputs?.cardNumber);
    } else {
      setErrorPopUp({
        res: CUSTOM_MESSAGES().OS_GAME_CARD_NUMBER,
        noErrorTxt: true,
      });
    }
  }
 const handleGamecardclose = (e) => {
  if (props.checkbalance && urlSearchParams("type") === "balance") {
       props.navigate(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`,  {
      replace: true,
    });
  } else {
    handleClosePopup();
  }
};

  // HTML CSS Code

  return (
    <div
      ref={ref}
      className={cn(
        'col-12 px-0 col-md-12 mx-0 h-100 rowReverse position-realtive'
      )}
      style={{
        backgroundColor: serverAppTheme.popUp_bg,
        boxShadow: serverAppTheme?.popUp_box_shadow,
        color: serverAppTheme?.primary_text,
      }}
    >
      {loading && <Loader />}
      <ModalHeader
        // isTab={props.seat?.tab}
        // stationName={props.seat?.stationName}
        tileHeader="Game Card"
        // seatNumber={props.seat?.number}
      />
            <div className="col-12 px-0 py-4 d-flex flex-column align-items-center" style={{top: orderingPortraitOrientation ? (entryMethods.includes('swipe') && entryMethods.includes('type') ? '12%' : (entryMethods.includes('type') ? '24%' : '')) : ''}}>
        {entryMethods.includes('swipe') && (
          <div className={cn('mb-2' ,orderingPortraitOrientation ?'col-12 px-3' :'col-8 px-1')}>
            <TouchableButton
              type="submit"
              className={cn(
                'col-12 btn-ripple border-0 rounded text-white fs_24 fw-600'
              )}
              style={{
                height: orderingPortraitOrientation ?'64px' : '8.6vh',
                backgroundColor: serverAppTheme?.secondaryBtn,
                color: serverAppTheme?.btn_font_color,
              }}
              onClick={e => {
                e.preventDefault();
                openCardPopUp();
              }}
              rippleEffect={true}
            >
              {LABEL().SWIPE_CARD}
            </TouchableButton>
          </div>
        )}
        {entryMethods.includes('swipe') &&
          entryMethods.includes('type') && (
            <div className="col-8 px-0 d-flex align-items-center justify-content-center my-1 fw-600">
              OR
            </div>
          )}
        {(entryMethods === null ||
          entryMethods.length === 0 ||
          entryMethods.includes('type') ||
          entryMethods.includes('')) && (
          <div
            className={cn(
              'd-flex flex-column align-items-center mt-2' ,orderingPortraitOrientation ? 'col-12 px-3' : 'col-8 px-1'
            )}
            
          >
            <div className="col-12 px-0 position-relative">
              <input
                value={getInput('cardNumber')}
                className={cn('form-control rounded-0 fs_24 pl-3', style.input)}
                type="text"
                style={{
                  height: orderingPortraitOrientation ? '64px' : '8.6vh',
                  backgroundColor: serverAppTheme?.inputBg,
                  border: 'none',
                  borderBottom: serverAppTheme?.inputBorder_Bottom,
                  color: serverAppTheme?.primary_text,
                  '--placeholder-color': serverAppTheme?.input_placeholder,
                }}
                id="cardNumber"
                name="cardNumber"
                onFocus={() => {
                  handleChangeInput('securityCode');
                  setActiveElement('cardNumber');
                  handleBlur();
                }}
                placeholder={CUSTOM_MESSAGES().ENTER_GAME_CARD_NUMBER}
              />
              {inputs?.cardNumber?.length > 0 && (
                <TouchableDiv
                  role="presentation"
                  className="position-absolute"
                  style={{
                    top: '50%',
                    right: '1%',
                    transform: 'translateY(-50%)',
                  }}
                  onClick={e => {
                    e.preventDefault();
                    setEmpty('cardNumber');
                    setActiveElement('cardNumber');
                  }}
                >
                  <Cross fill={serverAppTheme?.iconcolor} alt="X" />
                </TouchableDiv>
              )}
            </div>
          </div>
        )}
      </div>
      {(entryMethods === null ||
        entryMethods.length === 0 ||
        entryMethods.includes('type') ||
        entryMethods.includes('')) && (
        <div
          className={cn("d-flex align-items-center justify-content-center mt-3 col-12  position-absolute" ,orderingPortraitOrientation ?'px-3' :'px-0')}
          style={{ bottom: '3%' }}
        >
          <TouchableButton
            type="cancel"
            className={cn(
              'px-0 btn-ripple d-flex justify-content-center align-items-center rounded fs_28 fw-600 mr-2', orderingPortraitOrientation ?'col-6' :'col-5'
            )}
            style={{
              backgroundColor: serverAppTheme?.OFF_Premise_Btn,
              border: serverAppTheme?.cancleBtn_Border,
              color: serverAppTheme?.cancleBtn_font,
              height: '8.6vh',
            }}
            onClick={e => {
              e.preventDefault();
              props.navigate(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`, {
                replace: true,
              });
            }}
            rippleEffect={true}
          >
            {LABEL().CANCEL}
          </TouchableButton>
          <TouchableButton
            type="submit"
            className={cn(
              'px-0 border-0 btn-ripple d-flex justify-content-center align-items-center rounded fs_28 fw-600', orderingPortraitOrientation ? 'col-6' :'col-5'
            )}
            style={{
              height: '8.6vh',
              backgroundColor:
                serverAppTheme?.secondaryBtn,
              color:
                serverAppTheme?.btn_font_color,
            }}
            onClick={e => {
              e.preventDefault();
              handleApplyGameCard();
            }}
            rippleEffect={true}
          >
            {LABEL().APPLY}
          </TouchableButton>
        </div>
      )}
      {entryMethods?.length === 1 && entryMethods?.includes("swipe") && (
        <div
        className="d-flex align-items-center justify-content-center mt-3 col-12 px-0 position-absolute"
        style={{ bottom: '3%' }}
      >
        <TouchableButton
          type="cancel"
          className={cn(
            'col-5 px-0 btn-ripple d-flex justify-content-center align-items-center rounded fs_24 fw-600 mr-2'
          )}
          style={{
            backgroundColor: serverAppTheme?.OFF_Premise_Btn,
            border: serverAppTheme?.cancleBtn_Border,
            color: serverAppTheme?.cancleBtn_font,
            height: '8.6vh',
          }}
          onClick={e => { e.preventDefault(); handleGamecardclose();}}
          rippleEffect={true}
        >
          {LABEL().CLOSE}
        </TouchableButton>
        </div>
      )}
      {entryMethods?.includes("type") && (
        // swipedDown
        <div
          className={cn('p-2 position-fixed mt-2', orderingPortraitOrientation ? 'w-94' :'w-100')}
          style={{
            bottom: orderingPortraitOrientation ? '32%' : '14%',
            left: 0,
            margin : orderingPortraitOrientation ?  '0 16px' : '',
            backgroundColor: serverAppTheme?.keyBoard_Bg_Color,
          }}
        >
          <CustomKeyboard
            onClickBtn={onClickBtn}
            type="number"
            closeKeyboard={closeKeyboard}
            btnSize="btn15"
            customClass="fs-30"
            maxLength={30}
            setinputEmpty={setEmpty}
            tableKeyHeight
          />
        </div>
      )}
      <FullWidthModal
        isOpen={isSwipe}
        noBackground
        customClass2={cn(style.QrModalWidth, 'p-3 h-100')}
        style={{
          borderRadius: '16px',
          backgroundColor: '#2F2F2F',
          height: '100%',
          width: '100%',
          border: '1px solid #9f9f9f',
        }}
      >
        <div className="col-12 p-3 justify-content-center align-items-center position-relative text-center h-100">
          <div
            style={{ top: '0.8rem', right: '0.8rem', zIndex: '999' }}
            className="position-absolute"
          >
            <Cross
              fill={serverAppTheme?.iconcolor}
              role="presentation"
              onClick={() => {
                handleStopMagneticRead();
              }}
              className=" fs-24 fw-normal"
              aria-hidden="true"
            />
          </div>
          <div className="col-12 px-0 h-100">
            <div className="col-12 h-8 d-flex justify-content-center fs-22 fw-600 text-white">
              {CUSTOM_MESSAGES().SWIPE_CARD_AFTER_BEEP}
            </div>
            <div className="col-12 p-1 h-78">
              {/* <LazyLottieLoader
                style={{ height: '100%' }}
                animationData={swipeGameCard}
                loop={true}
                autoplay={true}
                speed={1}
              /> */}
              <img src={swipeGameCard}  alt="success" style={{width:'50%', height:'100%'}} />
            </div>
            <div
              className="col-12 px-0 py-1 h-12 position-absolute"
              style={{ bottom: 0 }}
            >
              <button
                className="col-4 px-0 border-0 rounded btn-ripple fs_24 fw-600 text-white"
                type="button"
                onClick={() => {
                  handleStopMagneticRead();
                }}
                style={{
                  height: '8.6vh',
                  backgroundColor: '#0060FF',
                }}
              >
                {LABEL().CANCEL}
              </button>
            </div>
          </div>
        </div>
      </FullWidthModal>
      <Modal isOpen={cardError} isModalCenter>
        <div className="row mb-0">
          <div
            className="col-12 mt-20 mb-20 justify-content-center align-items-center text-center"
            style={{ fontSize: '3vw' }}
          >
            {cardError}
          </div>
          <div className="col-12 mt-20 mb-20 justify-content-center align-items-center text-center">
            <button
              className="btn w-50 od-btn-primary btn-primary btn-ripple mr-1 fs-20"
              type="button"
              onClick={() => handleClosePopuo()}
              style={{
                height: '9vh',
                fontSize: '5vh',
              }}
            >
              {LABEL().CLOSE}
            </button>
          </div>
        </div>
      </Modal>
      <FullWidthModal
        isOpen={balancePopUp.state}
        noBackground
        customClass2={cn(style.QrModalWidth, ' h-100')}
        style={{
          backgroundColor: serverAppTheme.popUp_bg,
          borderRadius: '16px',
          border: serverAppTheme?.popupBorder,
          boxShadow: serverAppTheme?.popUp_box_shadow,
          height: '100%',
          width: '100%',
        }}
      >
         <div className="d-flex flex-column" style={{ color: props.serverAppTheme?.primary_text}}>
                  <ModalHeader
                    tileHeader="Game Card Balance"
                  />
                  </div>
        <div
          className="col-12 p-3 justify-content-center align-items-center position-relative text-center h-100"
          style={{ color: serverAppTheme?.primary_text }}
        >
          <div className="col-12 px-0 h-100">
            <div className="col-12 h-5 d-flex justify-content-center fs-22 fw-600 ">
              {LABEL().CARDNUMBER +
                ': ' +
                balancePopUp?.data?.displayCardNumber}
            </div>
            <div
              style={{ padding: '0.74rem 0' }}
              className={cn("col-12 px-0  d-flex align-items-center", orderingPortraitOrientation ?'h-10' : 'h-15')}
            >
              <div
                className="col-6 px-0 h-100 rounded-left d-flex justify-content-center align-items-center fw-500"
                style={{
                  backgroundColor: !balTran
                    ? serverAppTheme?.gameCard_selected_tab
                    : 'transparent',
                  color: !balTran ? 'black' : serverAppTheme?.primary_text,
                  fontWeight: !balTran ? '500' : '400',
                  border: '1px solid #79747E',
                }}
                onClick={() => setBalTran(false)}
              >
                {LABEL().BALANCE}
              </div>
              <div
                className="col-6 px-0 h-100 rounded-right d-flex justify-content-center align-items-center fw-500"
                style={{
                  backgroundColor: balTran
                    ? serverAppTheme?.gameCard_selected_tab
                    : 'transparent',
                  color: balTran ? 'black' : serverAppTheme?.primary_text,
                  fontWeight: balTran ? '500' : '400',
                  border: '1px solid #79747E',
                }}
                onClick={() => setBalTran(true)}
              >
                {LABEL().TRANSACTIONS}
              </div>
            </div>
            {!balTran ? (
              <div className="col-12 px-0 h-65 py-2 overflowY">
                {balancePopUp?.data?.rewards?.length > 0 ? (
                  <table
                    className={cn(' border-5' ,orderingPortraitOrientation ?'w-80 ml-5' :'w-90 mx-auto')}
                    style={{ border: serverAppTheme?.gameCard_table_border }}
                  >
                    {balancePopUp?.data?.rewards?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td
                            className={cn('border-5')}
                            style={{
                              padding: '15px 5px',
                              overflow: 'scroll',
                              border: serverAppTheme?.gameCard_table_border,
                            }}
                          >
                            {item.name}
                          </td>
                          <td
                            className={cn('border-5')}
                            style={{
                              padding: '15px 5px',
                              border: serverAppTheme?.gameCard_table_border,
                            }}
                          >
                            {item?.balance != null
                              ? Number(item.balance)?.toFixed(2)
                              : item.balance}
                          </td>
                        </tr>
                      );
                    })}
                  </table>
                ) : (
                  <div
                    className="col-12 d-flex justify-content-center align-items-center h-100 fs_18 fw-600"
                    style={{ color: serverAppTheme?.primary_text }}
                  >
                    No Rewards Found
                  </div>
                )}
              </div>
            ) : (
              <div className="col-12 px-0 h-65 py-2 overflowY">
                {balancePopUp?.data?.transactions?.length > 0 ? (
                  <table
                    className={cn('ml-5 border-5 w-80')}
                    style={{ border: serverAppTheme?.gameCard_table_border }}
                  >
                    {balancePopUp?.data?.transactions?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td
                            className={cn('border-5')}
                            style={{
                              padding: '15px 5px',
                              overflow: 'scroll',
                              border: serverAppTheme?.gameCard_table_border,
                            }}
                          >
                            {item.description}
                          </td>
                        </tr>
                      );
                    })}
                  </table>
                ) : (
                  <div
                    className="col-12 d-flex justify-content-center align-items-center h-100 fs_18 fw-600"
                    style={{ color: serverAppTheme?.primary_text }}
                  >
                    No Transactions Found
                  </div>
                )}
              </div>
            )}
            <div
              style={{ bottom: '35px' }}
              className="col-12 px-0 py-1 justify-content-center align-items-center text-center position-absolute"
            >
              <button
                className={cn("px-0 btn-ripple  fw-600 border-0  rounded",orderingPortraitOrientation ? 'col-6 fs_28' : 'col-4 fs_24')}
                type="button"
                onClick={() => {
                 handleGamecardclose();
                }}
                style={{
                  height: '8.6vh',
                  backgroundColor: serverAppTheme?.secondaryBtn,
                  color: serverAppTheme?.btn_font_color,
                }}
              >
                {LABEL().OK}
              </button>
            </div>
          </div>
        </div>
      </FullWidthModal>
    </div>
  );
};

export default CardEntry;
